import { Injectable } from '@angular/core';
import { App, AppService } from './app.service';
import { MessageService, MessageWindowOnFocus } from './message.service';
import { UtilService } from './util.service';
declare var chrome: any;

@Injectable({
  providedIn: 'root'
})
export class AppInstallService {
  public numAppsToInstall: number = 0; // default 1 for mobile; ext and pwa added by other services

  public isChrome: boolean = false;
  public isEdge: boolean = false;
  public canInstallChromeExt: boolean = true;
  public pwaInstallSupported: boolean = false;
  public canInstallPWA: boolean = false;
  public canInstallMobile: boolean = true;
  public installPopupType = 'mobile';
  public shownInstallPopup: boolean = false;

  constructor(
    private utilService: UtilService,
    private messageService: MessageService
  ) {
    this.countAppsToInstall();
    this.isChrome = this.utilService.isChrome();
    this.isEdge = this.utilService.isEdge();
    this.setCanInstallChromeExt();

    this.messageService.getMessage().subscribe(message => {
      if (message.name === MessageWindowOnFocus) {
        this.setCanInstallChromeExt();
      }
    });
  }

  public countAppsToInstall() {
    console.log("countAppsToInstall", { ext: this.canInstallChromeExt, pwa: this.canInstallPWA, mobile: this.canInstallMobile });
    this.numAppsToInstall = 0;
    if (this.isChrome && this.canInstallChromeExt) {
      this.numAppsToInstall++;
    }
    if (this.pwaInstallSupported && this.canInstallPWA) {
      this.numAppsToInstall++;
    }
    if (this.canInstallMobile) {
      this.numAppsToInstall++;
    }
  }

  public setCanInstallChromeExt() {
    try {
      if (AppService.appName === App.pw) {
        if (this.utilService.isChrome() || this.utilService.isEdge()) {
          if (this.utilService.isChrome()) {
            this.isChrome = true;
          } else {
            this.isEdge = true;
          }
          chrome.runtime.sendMessage(
            this.utilService.getEndpoint('chromeExtensionId'),
            { action: 'isinstall' },
            (res) => {
              console.log("ext isinstall", res);
              this.setChromeExtInstalled(res);
            });
        } else {
          this.setChromeExtInstalled(false);
        }
      } else {
        this.setChromeExtInstalled(false);
      }
    } catch (err) {
      this.setChromeExtInstalled(false);
    }
  }

  public setChromeExtInstalled(val) {
    console.log("setChromeExtInstalled", val);
    if (val) {
      this.canInstallChromeExt = false;
    } else {
      this.canInstallChromeExt = true;
    }
    this.countAppsToInstall();
  }

  public setMobileInstalled(val) {
    if (val) {
      this.canInstallMobile = false;
      this.installPopupType = 'ext';
    } else {
      this.canInstallMobile = true;
    }
    this.countAppsToInstall();
  }

  public setPWAInstalled(val) {
    if (val) {
      this.canInstallPWA = false;
    } else {
      this.canInstallPWA = true;
    }
    this.countAppsToInstall();
  }
}
